const __request = require(`@/lib/data-service/default/__request/`)

/**
 *国际城市搜索
 */
export default function getInternational(val) {
    var pParameter = {}
    pParameter.method = "POST"
    pParameter.urlSuffix = "/web/common/area/getInternationalAreaChildListByParentIdResponse"
    pParameter.data = val
    return new Promise(function (resolve, reject) {
        resolve(__request(pParameter))
    })
}